type SectionHeadingProps = {
  eyebrow: string;
  icon: string;
  title: string;
  desc: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({
  eyebrow,
  icon,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs font-medium tracking-wide text-secondary-900 ${
          isCenter ? 'justify-center' : ''
        }`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={`${icon} text-sm`}></i>
        </span>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
    </div>
  );
}